import { Button, Card, Divider, Flex, Tag, Typography } from 'antd';
import { Navigate, useParams } from 'react-router-dom';
import OnboardingShell from '../../components/OnboardingShell';
import { useOnboarding } from '../../context/OnboardingContext';
import { useTelegram } from '../../context/TelegramContext';
import { formatDateTime } from '../../utils/format';
import { buildBotPath } from '../../utils/routes';
import { SUPPORT_LINK, openTelegramLink } from '../../utils/telegramLink';

/**
 * Shown while the custom 6 month block earned by cancelling on purpose is in effect. This is not a
 * Telegram ban — the user simply cannot subscribe or pay until `blocked_until`.
 */
const BlockedPage = () => {
    const { bot_id } = useParams();
    const { isInitializing, subscriptionStatus } = useOnboarding();
    const { webApp } = useTelegram();
    const block = subscriptionStatus?.block;

    if (isInitializing) {
        return null;
    }

    // Landing here without an active block (support lifted it, or it just expired) means the normal
    // flow should take over.
    if (!block || block.state !== 'active') {
        return <Navigate to={buildBotPath(bot_id, '/onboarding')} replace />;
    }

    return (
        <OnboardingShell
            title="Obuna bloklangan"
            subtitle="Obunani bekor qilganingiz sababli qayta obuna bo'lish vaqtincha cheklangan."
        >
            <Flex vertical gap={16}>
                <Card className="info-panel" bordered={false}>
                    <Flex justify="space-between" align="center" wrap gap={12}>
                        <div>
                            <Typography.Text className="muted-label">Holat</Typography.Text>
                            <Typography.Title level={4} className="section-title">
                                Bloklangan
                            </Typography.Title>
                        </div>
                        <Tag color="error">Faol emas</Tag>
                    </Flex>
                    <Divider />
                    <Typography.Paragraph className="section-text">
                        Blok tugash sanasi: {formatDateTime(block.blocked_until)}
                    </Typography.Paragraph>
                    <Typography.Paragraph className="section-text">
                        Qolgan muddat: {block.days_left} kun
                    </Typography.Paragraph>
                </Card>

                <Card className="info-panel" bordered={false}>
                    <Typography.Paragraph className="section-text">
                        Shu sanagacha qayta obuna bo'lish va to'lov qilish imkoni yo'q. Savollaringiz
                        bo'lsa, qo'llab-quvvatlash xizmatiga murojaat qiling.
                    </Typography.Paragraph>
                    <Button
                        block
                        type="primary"
                        href={SUPPORT_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(event) => openTelegramLink(webApp, SUPPORT_LINK, event)}
                    >
                        Qo'llab-quvvatlash
                    </Button>
                </Card>
            </Flex>
        </OnboardingShell>
    );
};

export default BlockedPage;
